<div class="ordering-widget">
  <lib-question-hint
    [hint]="'SLIDES.put_the_cards_in_correct_order' | translate">
  </lib-question-hint>

  <div class="ordering-question" cdkDropListGroup>
    <div class="ordering-question-containers">
      @for (item of containers; track item; let index = $index) {
        <div
          class="animate__animated ordering-question-container"
          cdkDropList
          [cdkDropListData]="{ index: index }"
          (cdkDropListDropped)="drop($event)"
          (click)="dropActiveOptionToContainer(index)"
          [ngClass]="animation"
          [style.animationDelay.ms]="animationDelay + index * 200">
          <lib-question-answer-option-code
            class="ordering-indicator"
            [numeric]="true"
            [index]="index">
          </lib-question-answer-option-code>
          @if (output[index]; as option) {
            <lib-question-option
              class="ordering-question-option"
              cdkDrag
              [cdkDragData]="option"
              (cdkDragStarted)="setActiveOption(null)"
              cdkDragPreviewClass="ordering-question-option-preview"
              (click)="setActiveOption(option)"
              [index]="option.index"
              [text]="option.text"
              [active]="option.hash === activeOption?.hash">
            </lib-question-option>
          }
        </div>
      }
    </div>

    <div class="ordering-question-options-container">
      <div
        class="animate__animated ordering-question-options"
        [ngClass]="animation"
        [style.animationDelay.ms]="animationDelay"
        cdkDropList
        (cdkDropListDropped)="drop($event)"
        [cdkDropListData]="{ index: -1 }">

        @if (options.length === 0) {
          <div class="options-empty">
            <lib-icon icon="check-circle" class="options-empty-icon"></lib-icon>
          </div>
        }


        @for (item of options; track item; let i = $index) {
          <lib-question-option
            class="ordering-question-option"
            cdkDrag
            [cdkDragData]="item"
            (cdkDragStarted)="setActiveOption(null)"
            (click)="setActiveOption(item)"
            [index]="item.index"
            [text]="item.text"
            [active]="item.hash === activeOption?.hash"
            cdkDragPreviewClass="ordering-question-option-preview">
          </lib-question-option>
        }

      </div>
    </div>
  </div>
</div>
